enum OfferItemType {
  OFFER = 'offer',
  REQUEST = 'request',
}

export { OfferItemType };
